import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STInvoiceFilter = ({ data = [], onClose }) => {
  const navigate = useNavigate();

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [invoiceNumbers, setInvoiceNumbers] = useState(['']);

  const handlePrint = () => {
    const filteredData = data.filter((item) => {
      if (fromDate && new Date(item.TanggalNota) < new Date(fromDate)) return false;
      if (toDate && new Date(item.TanggalNota) > new Date(toDate)) return false;
      return true;
    });

    const printableData = filteredData.map((item) => ({ ...item }));

    navigate('/st-invoice-preview', {
      state: {
        fromDate,
        toDate,
        invoiceNumbers,
        filteredData: printableData,
      },
    });
  };

  const handleInvoiceChange = (index, value) => {
    const updated = [...invoiceNumbers];
    updated[index] = value;
    setInvoiceNumbers(updated);
  };

  const addInvoiceField = () => {
    setInvoiceNumbers([...invoiceNumbers, '']);
  };

  return (
    <div
  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
  onClick={onClose}
>
  <div
    className="bg-white rounded-xl shadow-lg p-4 sm:p-5 w-full max-w-xl max-h-[90vh] overflow-y-auto"
    onClick={(e) => e.stopPropagation()}
  >
    <h3 className="mb-4 text-base font-semibold text-gray-800 sm:text-lg">Filter Serah Terima Invoice</h3>

    {/* Form Fields */}
    <div className="grid grid-cols-1 gap-3 mb-4 sm:grid-cols-2">
      <div>
        <label className="block mb-1 text-xs font-medium text-gray-700">Dari Tanggal Nota</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
      <div>
        <label className="block mb-1 text-xs font-medium text-gray-700">Sampai Tanggal Nota</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
    </div>

    {/* Nomor Invoice Section */}
    <div className="mb-4">
      <label className="block mb-1 text-xs font-medium text-gray-700">Nomor Invoice</label>
      <div className="space-y-2">
        {invoiceNumbers.map((num, index) => (
          <input
            key={index}
            type="text"
            value={num}
            onChange={(e) => handleInvoiceChange(index, e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
            placeholder={`Nomor Invoice ${index + 1}`}
          />
        ))}
      </div>
      <button
        onClick={addInvoiceField}
        className="mt-2 text-xs text-blue-600 hover:underline"
      >
        + Tambah Nomor Invoice
      </button>
    </div>

    {/* Buttons */}
    <div className="flex justify-end gap-3 mt-5">
      <button
        onClick={handlePrint}
        className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1.5 rounded-md shadow-sm transition"
      >
        Preview
      </button>
      <button
        onClick={onClose}
        className="bg-gray-400 hover:bg-gray-500 text-white text-xs px-3 py-1.5 rounded-md shadow-sm transition"
      >
        Batal
      </button>
    </div>
  </div>
</div>

  );
};

export default STInvoiceFilter;
